export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ11.cbba66ae.mp3";